const routes = [
  {
    index: true,
    label: 'Qian Cheng',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Publications and Patents',
    path: '/publications',
  },
  {
    label: 'News and Recognition',
    path: '/projects',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
